import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AbstractApiDataService } from './abstract-api-data.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export abstract class BaseApiDataService<TData> extends AbstractApiDataService {

  constructor(protected http: HttpClient) { super(); }

  get(requestUrl: string, params?: HttpParams): Observable<TData> {
    return this.http.get<TData>(requestUrl, { params })
      .pipe(
        catchError(this.handleError<TData>('get')),
      );
  }

  // GET: /api/legalentity/:id
  getById(requestUrl: string, id: string | number, params?: HttpParams): Observable<TData> {
    const url = `${requestUrl}/${id}`;
    return this.http.get<TData>(url, { params })
      .pipe(
        catchError(this.handleError<TData>(`get by id=${id}`)),
      );
  }

  // GET: /api/legalentity
  list(requestUrl: string, params?: HttpParams): Observable<TData[]> {
    return this.http.get<TData[]>(requestUrl, { params })
      .pipe(
        catchError(this.handleError('list', [])),
      );
  }

  // POST: /api/entity
  post(requestUrl: string, dto: TData): Observable<TData> {
    return this.http.post<TData>(requestUrl, dto, httpOptions).pipe(
      catchError(this.handleError<TData>('post')),
    );
  }

  postForm(requestUrl: string, dto: TData): Observable<TData> {
    return this.http.post<TData>(requestUrl, dto).pipe(
      catchError(this.handleError<TData>('post')),
    );
  }

}
